import React, { useEffect, useState } from 'react';
import styles from './login.module.css';
import { Blocked,   calendar_white,   circleinline, email_color, link_circle_white, log_out, Whatsapp } from '../../assets';
import Typography from '../../design-system/lib/Typography';
import { useTranslation } from 'react-i18next';
import Button from '../../design-system/lib/Button';
import { padding } from 'polished';
import { LogoutHttp } from '../../helper/api';
import { DispatcherApi } from '../../service/API/dispatcher';
import { get_id, get_refreshToken } from '../../helper/UserData/userdate';
import { useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';



export function BlockSuspendLayout(props) {
    const { t, i18n } = useTranslation();
    const [isBlock, setIsBlock] = useState(false);
    const [isActive, setIsActive] = useState(false);
  const [linkPay, setLinkPay] = useState("");

  const dispatch = useDispatch();



 
    useEffect(async () => {
        const Dispatcher = new DispatcherApi();
        
        const data = await Dispatcher.Setting({ userId: get_id(), refreshToken: get_refreshToken() });

        console.log("data project ", data)

        if (data) {
            if (data.project && data.project.subscriptionStatus == "expired" || data.project.subscriptionStatus == "suspended") {
                setLinkPay(data.project.paymentLink)
                setIsActive(true)
                if (data.project.subscriptionStatus == "expired") {
                    setIsBlock(true)
                }
                dispatch({ type: "isNetworkDisabled", state: true });
            }

        }
 
    }, [])

        
    if (!isActive) {
        return null
    }
    return <div
        className={styles.App}
    >
        <div className={styles.formContainer}>
            <img src={Blocked} style={{ width: "28px" }} />
            <Typography weight='Heading_Small_Bold' text={t(isBlock ? "Your Free Trial Has Ended" : "Account Suspended")} style={{marginTop:"8px" , color:"rgba(36, 36, 36, 1)"}} />
            <Typography weight='Body_Middle_Medium' text={t(isBlock ? "To extend your trial or subscribe with Onro, please use one of the direct options below to connect with us." : "Your account has been suspended due to unpaid invoices. To reactivate your account, please complete your payment using below options.")} style={{marginTop:"8px" , color:"rgba(72, 72, 72, 1)",textAlign:"center",direction:"initial"}} />
          {(isBlock ? true : !isEmpty(linkPay)) && <Button size='Medium' type='Primary' icon={isBlock ? calendar_white : link_circle_white} style={{marginTop:"16px" ,maxWidth:"100% !important"}} text={t(isBlock ? "Book a meeting" : "Pay Now with payment link")} className={styles.directionButton}
            onClick={()=>{
                window.open(isBlock ? `https://calendly.com/onro/demo` : linkPay, "_blank");
            }}
             />}


{isBlock ? <>
      <Button size='Medium' type='Secondary' icon={Whatsapp} style={{marginTop:"12px" ,maxWidth:"100% !important" ,width:"320px"}} text={"WhatsApp: +37066515455"} className={styles.directionButton} onClick={()=>{
                window.open(`https://wa.me/+37066515455`, "_blank");
            }}/>
            <Button size='Medium' type='Secondary' icon={email_color} style={{marginTop:"12px" ,maxWidth:"100% !important",width:"320px"}} text={"Email: mosayeb@onro.io"} className={styles.directionButton} onClick={()=>{
                window.open(`mailto:mosayeb@onro.io`, "_blank");
             }} />
</>
:
<>   <Button size='Medium' type='Secondary' icon={email_color} style={{marginTop:"12px" ,maxWidth:"100% !important",width:"320px"}} text={"Email: accounts@onro.io"} className={styles.directionButton} onClick={()=>{
                window.open(`mailto:accounts@onro.io`, "_blank");
             }} />
      <Button size='Medium' type='Secondary' icon={Whatsapp} style={{marginTop:"12px" ,maxWidth:"100% !important" ,width:"320px"}} text={"WhatsApp: +37069100207"} className={styles.directionButton} onClick={()=>{
                window.open(`https://wa.me/+37069100207`, "_blank");
            }}/>
         
</>
}
 
            <div style={{width:"300px",height:"1px",backgroundColor:"rgba(241, 241, 241, 1)",display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center",marginTop:"20px"}}><Typography weight='Body_Small_Regular' text={t("OR")} style={{ color:"rgba(72, 72, 72, 1)" ,padding:"0px 8px",backgroundColor:"white"}} /></div>
            <Button size='Medium' type='Tertiary' icon={log_out} style={{marginTop:"20px" }} text={t("Logout")} className={styles.directionButton2} onClick={LogoutHttp} />

        </div>
    </div>

}


